// Brand palette extracted from solarjuice.com.au theme CSS,
// then warmed up so the in-game UI reads as "blueprint slate" rather than near-black.
export const BRAND = {
  red: 0xdb1215,
  redDark: 0xa50e10,
  orange: 0xfc5732,
  amber: 0xfdbc1a,
  amberSoft: 0xffd35e,
  // Surfaces: lightened from near-black to a warm slate
  ink: 0x2a3140, // canvas / page deep slate
  inkSoft: 0x3a4250, // sidebar / cards
  inkLine: 0x1c222d, // dividers, fine lines
  surface: 0x4b5564, // raised card / hover
  // Cream / page-light surfaces (used in HTML chrome and result card)
  cream: 0xf4f1ec,
  // Grays
  grey: 0xebebeb,
  greyMid: 0xc4c4c4,
  greyDim: 0x8a93a3, // muted text on dark
  greyDark: 0x545b68,
  white: 0xffffff,
  // Roof
  shadeRoof: 0x4a5360,
  shadeRoofHi: 0x5a6473,
  shadeRoofLine: 0x232934,
  // Sky band at top of play area
  skyTop: 0x55719a,
  skyBot: 0x3e526e,
} as const;

export const HEX = {
  red: '#db1215',
  orange: '#fc5732',
  amber: '#fdbc1a',
  amberSoft: '#ffd35e',
  ink: '#2a3140',
  inkSoft: '#3a4250',
  cream: '#f4f1ec',
  white: '#ffffff',
  grey: '#ebebeb',
  greyDim: '#8a93a3',
} as const;

// Supersample the canvas backing store on HiDPI / Retina displays so the
// fixed 1024×640 layout renders crisp instead of being upscaled by the browser.
// Phaser 3 sizes the canvas to the logical game size and ignores devicePixelRatio,
// so we render larger and present the same layout through a camera zoom.
export const RENDER_SCALE = Math.min(
  Math.max(1, Math.round((typeof window !== 'undefined' ? window.devicePixelRatio : 1) || 1)),
  2,
);

export const GAME = {
  width: 1024,
  height: 640,
  cell: 56, // px per grid cell
  // Orientation falloff: how strongly off-axis panels lose output.
  // multiplier = max(MIN, cos(deltaRadians))
  minOrientationMultiplier: 0.3,
} as const;

export const FONT = {
  ui: 'Albert Sans, system-ui, sans-serif',
  display: 'Albert Sans, system-ui, sans-serif',
} as const;
